/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { makeStyles, Grid, Typography } from '@material-ui/core';

import IconFilePdf from '../../assets/images/ic-file-pdf.svg';
import TableFooter from '../common/TableFooter';
import SimpleTooltip from '../simpleTooltip/SimpleTooltip';

const useStyles = makeStyles((theme) => {
  return {
    imageFile: {
      left: '8px',
      position: 'absolute',
      top: '8px',
      width: '28px',
    },
    thumbnailContainer: {
      backgroundColor: '#F5F5F5',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      cursor: 'pointer',
      paddingBottom: '80%',
      position: 'relative',
      width: '100%',
    },
    typographyContainer: {
      marginTop: '8px',
      padding: '0px 8px',
    },
    typographyNoThumbnail: {
      color: '#999999',
      fontSize: '16px',
      fontWeight: 'bold',
      left: '50%',
      position: 'absolute',
      top: '50%',
      transform: 'translate(-50%, -50%)',
    },
    typographyNotAvailable: {
      color: '#999999',
      fontSize: '16px',
      lineHeight: '20px',
      textAlign: 'center',
    },
    typographySize: {
      color: '#999999',
      fontSize: '14px',
      lineHeight: '14px',
      marginTop: '4px',
      textAlign: 'left',
    },
    typographyTitle: {
      color: '#172B4D',
      cursor: 'pointer',
      fontSize: '16px',
      fontWeight: '600',
      lineHeight: '20px',
      textAlign: 'left',
      wordBreak: 'break-word',
      wordWrap: 'break-word',
    },
  };
});

export default ({ documents, total, onOpenViewer, criteria, onPageUpdate }) => {
  const classes = useStyles();
  const handleOpenViewer = (data) => {
    if (onOpenViewer) onOpenViewer(data);
  };

  const handlePageUpdate = (page) => {
    if (onPageUpdate) onPageUpdate(page);
  };

  const renderDocuments = () => {
    return documents.map((document) => {
      const fileSize = {
        rendered: '-',
        unit: 'KB',
        value: (document?.resource?.size || 0) / 1024,
      };

      if (fileSize.value >= 1000) {
        fileSize.value /= 1024;
        fileSize.unit = 'MB';
      }

      if (fileSize.value > 0) fileSize.rendered = fileSize.value.toFixed(2) + fileSize.unit;
      const thumbnailPath = document?.resource?.customThumbnailPath || document?.resource?.thumbnailPath;

      if (!thumbnailPath) {
        return (
          <Grid key={`${document.id}_${document.resource.id}`} item xs={12} sm={6} md={4} lg={2}>
            <div onClick={() => handleOpenViewer(document)} className={classes.thumbnailContainer} style={{ position: 'relative' }}>
              <img className={classes.imageFile} src={IconFilePdf} alt="pdf-icon" />

              <Typography className={classes.typographyNoThumbnail}>ARTICLE</Typography>
            </div>

            <div className={classes.typographyContainer}>
              <Typography onClick={() => handleOpenViewer(document)} className={classes.typographyTitle}>
                {document.title}
              </Typography>
              <Typography onClick={() => handleOpenViewer(document)} className={classes.typographySize}>
                Size: {fileSize.rendered}
              </Typography>
            </div>
          </Grid>
        );
      }

      return (
        <Grid key={`${document.id}_${document.resource.id}`} item xs={12} sm={6} md={4} lg={2}>
          <div onClick={() => handleOpenViewer(document)} className={classes.thumbnailContainer} style={{ backgroundImage: `url(${thumbnailPath})`, position: 'relative' }}>
            <img className={classes.imageFile} src={IconFilePdf} alt="pdf-icon" />
          </div>

          <div className={classes.typographyContainer}>
            <SimpleTooltip title={document?.description || ''} disabled={!document?.description} placement="bottom">
              <Typography onClick={() => handleOpenViewer(document)} className={classes.typographyTitle}>
                {document.title}
              </Typography>
            </SimpleTooltip>
            <Typography onClick={() => handleOpenViewer(document)} className={classes.typographySize}>
              Size: {fileSize.rendered}
            </Typography>
          </div>
        </Grid>
      );
    });
  };

  if (!documents.length) {
    return <Typography className={classes.typographyNotAvailable}>No results found</Typography>;
  }

  return (
    <div>
      <Grid container spacing={3}>
        {renderDocuments()}
      </Grid>
      {!!documents.length && (
        <div>
          <TableFooter count={total} page={criteria.page} rowsPerPage={criteria.limit} changePage={(page) => handlePageUpdate(page)} />
        </div>
      )}
    </div>
  );
};
